<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";

export default {
  extends: baseList,
  
  data() {
    return {
      table: {
        mname: "make",
        key: "id",
        url: {},
        output: false,
      },
      menus: [
        {
          label: "预约列表",
          name: "make_list",
          auth: "/admin/make/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [
        // {label: '新增', icon: 'md-add', onClick: this.toAdd, auth1: '/admin/user/add'},
      ],
      tactions: [
        //   { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '用户数据', 0), auth: '/admin/user/lists' },
        //   { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '用户数据', 1), auth: '/admin/user/lists' },
      ],
      query: {},
      filters: [
        {label: '联系电话', name: 'linkman_mobile', value: '', type: 'input'},
      ],
      tableCols: [
        {
          title: "ID",
          key: "id",
          minWidth: 80,
          align: "center",
        },
        {
          title: "预约时间",
          key: "visit_time",
          minWidth: 140,
          align: "center",
        },
        {
          title: "姓名",
          key: "linkman_name",
          minWidth: 120,
        },
        {
          title: "联系电话",
          key: "linkman_mobile",
          minWidth: 120,
        },
        {
          title: "预约人数",
          key: "amount",
          minWidth: 100,
        },
        // {
        //   title: "身份证号",
        //   minWidth: 120,
        //   key: "idcard_no",
        //   align: "center",
        // },
        {
          title: "提交时间",
          align: "center",
          key: "create_time",
          minWidth: 170,
        },
      ],
    };
  },
  
};
</script>
